var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install-app__steps-wrapper--plans-step"},[_c('billing-plans',{attrs:{"solutionId":_vm.solutionId},on:{"billing-plan-selected":_vm.billingPlansSelectedHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }